import { instance as globalStore } from './store';

import { KContext, bizBaseNameMap, bizHostMap, openNewPageParam } from './types';
import type { InstanceStore } from './plugins/upm';

import { getApp } from './../kastjs/dolly/share';

export const isLink = (path: string) =>
  typeof path === 'string' &&
  /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/.test(path.trim());

export class KCRM {
  // @ts-ignore
  private kContext: KContext;

  init(config: { kContext: KContext }) {
    this.kContext = config.kContext;
  }

  getSystemInfo() {
    const store = globalStore.getAll();
    return {
      env: store.env,
      source: store.source,
      upmSystemId: store.systemId,
      upmSubsystemName: store.currentSubSystemName,
    };
  }

  getUpmInfo() {
    const instance = globalStore.getAll<InstanceStore>()?.upmInstance;
    if (!instance) {
      console.warn('upm 未实例化');
    }
    return instance;
  }

  getUserInfo() {
    return globalStore.getAll().userData;
  }

  /**
   * 以新窗口打开页面。如果是相对地址，则会拼接上父应用的 baseName
   * @param url string
   */
  openPage(url: string) {
    if (isLink(url)) {
      window.open(url);
    } else {
      const basename = this.kContext?.appSettings?.router?.options?.basename || '/';
      window.open(basename + url.startsWith('/') ? url : `/${basename}`);
    }
  }

  async navigate(param: openNewPageParam) {
    let path = param?.path;
    if (!path) {
      console.error('openNewPage must has path');
      return;
    }
    const curBizName = this.kContext?.appSettings?.router?.options?.basename || '';
    const targetAppId = param.targetAppId;
    const targetBizName = param.targetBizName;
    let targetUrl = new URL(window.location.origin);

    if (!isLink(path)) {
      path = path.startsWith('/') ? path : `/${path}`;
    }
    // 跨应用
    if (targetAppId) {
      try {
        const targetApp = await getApp(targetAppId);
        const targetAppBaseName = targetApp?.basename;
        targetUrl.pathname = `${curBizName}${targetAppBaseName}${path}`;
        if (targetBizName) {
          const { KMI_ENV } = process.env;
          const ENV = KMI_ENV === 'local' || KMI_ENV === 'single' ? 'staging' : KMI_ENV;
          // @ts-ignore
          const targetHost = bizHostMap[targetBizName][ENV];
          const targetBizBaseName = bizBaseNameMap[targetBizName];
          if (!targetHost || !targetBizBaseName) {
            throw new Error(`${targetBizName}业务名称未查询到`);
          }
          targetUrl = new URL(targetHost);
          targetUrl.pathname = `${targetBizBaseName}${targetAppBaseName}${path}`;
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      targetUrl = new URL(curBizName + path, targetUrl);
    }
    window.open(targetUrl.href, param.target ? param.target : '_blank');
  }
}
